import React from "react";
import { Draggable } from "react-beautiful-dnd";

import styled, { css } from "styled-components";
import { Day } from "./Day";
import { useDispatch } from "react-redux";
import { IconButton } from "@material-ui/core";
import { removeTrack } from "./actions";
import ClearIcon from "@material-ui/icons/Clear";
interface TrackContainerProps {
    trackCount: number;
    sidebarWidth: number;
}

export const TrackContainer = styled.div<TrackContainerProps>`
    height: ${props => 100 / props.trackCount}%;
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: ${props => props.sidebarWidth}px 1fr;
    overflow: hidden;
`;

interface IIconButtonContainer {
    column: number;
    row: number;
}
export const IconButtonContainer = styled.div<IIconButtonContainer>`
    grid-column-start: ${props => props.column};
    grid-column-end: ${props => props.column};
    grid-row-start: ${props => props.row};
    grid-row-end: ${props => props.row};
    max-width: 20px;
    max-height: 20px;
    color: white;
`;

export const StyledIconButton = styled(IconButton)`
    && {
        width: 22px;
        height: 22px;
    }
`;
const TrackSidebar = styled.div`
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: 1;
    grid-column-end: 1;
    background: #3f52b5;
    display: grid;
    grid-template-rows: 50px 1fr 1fr;
    grid-template-columns: 20px 1fr 20px;
`;

const TrackMover = styled.div`
    grid-row-start: 1;
    grid-row-end: 4;
    grid-column-start: 1;
    grid-column-end: 1;
    background-color: #5066d8;
`;

const IconStyles = css`
    max-width: 20px;
    max-height: 20px;
    color: white;
`;

const StyledClearIcon = styled(ClearIcon)`
    ${IconStyles}
`;

interface ITrackTitle {
    title: string;
}

const TrackTitle = styled.div`
    color: white;
    padding: 10px;
`;

const TrackSubTitle = styled.div`
    color: white;
    padding-left: 10px;
    font-size: 12px;
    grid-row: 2;
    grid-column: 2;
`;

interface ITrackDays {
    weekCount: number;
}
const TrackDaysContainer = styled.div<ITrackDays>`
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: 2;
    grid-column-end: 2;
    background-color: white;
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: repeat(${props => props.weekCount * 7}, 1fr);
    border-radius: 5px;
    overflow: hidden;
`;

export interface TrackProps {
    id: string;
    name: string;
    index: number;
    trackCount: number;
    weekCount: number;
    sidebarWidth: number;
    days: Array<any>;
    reg: string;
}

export const Track = (props: TrackProps) => {
    const dispatch = useDispatch();
    return (
        <Draggable key={props.id} draggableId={props.id} index={props.index}>
            {provided => (
                <TrackContainer
                    {...provided.draggableProps}
                    ref={provided.innerRef}
                    trackCount={props.trackCount}
                    sidebarWidth={props.sidebarWidth}
                >
                    <TrackSidebar>
                        <TrackMover {...provided.dragHandleProps} />
                        <TrackTitle>{props.name}</TrackTitle>
                        <TrackSubTitle>{props.reg}</TrackSubTitle>
                        <IconButtonContainer column={3} row={1}>
                            <StyledIconButton
                                onClick={() =>
                                    dispatch(removeTrack(props.index))
                                }
                            >
                                <StyledClearIcon />
                            </StyledIconButton>
                        </IconButtonContainer>
                    </TrackSidebar>
                    <TrackDaysContainer weekCount={props.weekCount} title={""}>
                        {Array.isArray(props.days) &&
                            props.days.map((jobpacks, i) => {
                                return (
                                    <Day
                                        track={props.id}
                                        day={i}
                                        key={i}
                                        jobpacks={jobpacks}
                                    />
                                );
                            })}
                    </TrackDaysContainer>
                </TrackContainer>
            )}
        </Draggable>
    );
};
